import React from "react";
import "./style.css";
import CustomersCard from "./customersCard";
import { useSelector } from "react-redux";

const CustomersList = props => {
  const {
    accountantIdSelected,
    customers    
  } = props;

  const main = useSelector(state => state.main);

  /* useEffect(() => {
    if ((company && company.status && company.status.started) || !auth) return null;
    dispatch(loadCompany(
      "", 0, 40, null
    ));
    return undefined;
  }, [auth && auth.loginAuth && auth.loginAuth.securityToken]);*/

  const widgetList = () => {
    const arrayList = [];
    customers &&
      customers._embedded.customers.forEach(el => {
        const isCustomer = el.connected && el.subscribed;
        const isAvailableToUser = el.availableToUser;
        const isCompany = el.details.classifier === "COMPANY";
        const hasAddress =
          el.details.addresses &&
          Array.isArray(el.details.addresses) &&
          el.details.addresses[0] !== null;
        arrayList.push(<CustomersCard
          element={el}          
          accountantIdSelected={accountantIdSelected}
          companySelected={main.companySelected}
          isCustomer={isCustomer}
          isAvailableToUser={isAvailableToUser}
          isCompany={isCompany}
          hasAddress={hasAddress}
          isCustomersListView={true}
        />);
      });
    return arrayList;
  };

  return <div className="container">{widgetList()}</div>;
};

export default CustomersList;
